import React from 'react';
import PropTypes from 'prop-types';

const Connect = props => {
  const { color: _color, width: _width, height: _height, ...other } = props;

  return (
    <svg id="グループ_4182" data-name="グループ 4182" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" {...other}>
      <path id="パス_3708" data-name="パス 3708" d="M16,0A16,16,0,1,1,0,16,16,16,0,0,1,16,0Z" fill="#f2feff" />
      <g id="グループ_4185" data-name="グループ 4185" transform="translate(14.731 7.5) rotate(45)">
        <g id="グループ_4186" data-name="グループ 4186" transform="translate(0)">
          <path id="パス_3706" data-name="パス 3706" d="M3.726,7.452A3.726,3.726,0,1,1,7.452,3.726" transform="translate(0 3.398) rotate(-26)" fill="none" stroke="#00eaff" strokeLinecap="round" strokeWidth="1.5" />
          <path id="パス_3701" data-name="パス 3701" d="M3.726,0A3.726,3.726,0,1,1,.711,1.536" transform="translate(3.673 3.838) rotate(-31)" fill="none" stroke="#bffaff" strokeLinecap="round" strokeWidth="1.5" />
          <path id="パス_3702" data-name="パス 3702" d="M0,3.726a3.726,3.726,0,0,1,7.452,0" transform="matrix(0.985, -0.174, 0.174, 0.985, 0.666, 2.091)" fill="none" stroke="#00eaff" strokeLinecap="round" strokeWidth="1.5" />
        </g>
      </g>
    </svg>
  );
}

Connect.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

Connect.defaultProps = {
  color: '#f2feff',
  width: 32,
  height: 32,
};

export default Connect;



// WEBPACK FOOTER //
// ./src/components/Icons/Connect.jsx